import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

/**
 * MainContent
 *
 * This component is in charge of displaying
 * the Main Content of the app
 *
 * @return {jsx}
 */

const MainContent = ({ className, children }) => <main className={className}>{children}</main>;

/**
 * PropTypes Validation
 */
const { node, string } = PropTypes;
MainContent.propTypes = {
  className: string,
  children: node,
};

/**
 * Default Props
 */
MainContent.defaultProps = {
  className: '',
  children: null,
};

export default styled(MainContent)`
  height: 100%;

  padding: 3rem 0;

  /* For small devices */
  ${breakpoint('xs', 'md')`
    padding: 0;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/MainContent/index.js